export default {"src":"/_next/static/media/lead-careers.71b71239.svg","height":44,"width":706};